var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCamera(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M456 473h-16c-.552 0-1-.448-1-1s.448-1 1-1h16c.552 0 1-.448 1-1v-9c0-.552-.448-1-1-1h-4.28c-.43.001-.812-.273-.95-.68L450 457h-6l-.77 2.32c-.138.407-.52.681-.95.68H438c-.552 0-1 .448-1 1v11c0 .552-.448 1-1 1s-1-.448-1-1v-11c0-1.657 1.343-3 3-3h3.56l.54-1.63c.272-.819 1.038-1.37 1.9-1.37h6c.862 0 1.628.551 1.9 1.37l.54 1.63H456c1.657 0 3 1.343 3 3v9c0 1.657-1.343 3-3 3zm-5-8c0-2.21-1.79-4-4-4-.552 0-1 .448-1 1s.448 1 1 1c.871.002 1.64.568 1.902 1.399.262.83-.044 1.735-.757 2.237-.712.5-1.667.483-2.36-.043-.694-.527-.967-1.442-.675-2.263.148-.342.092-.738-.143-1.027-.235-.29-.612-.423-.977-.348-.365.075-.658.347-.76.705-.532 1.5-.124 3.174 1.04 4.26 1.164 1.087 2.862 1.38 4.323.746 1.46-.634 2.406-2.074 2.407-3.666z",
    transform: "translate(-435 -455)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.cf74e4f6.svg";
export { ForwardRef as ReactComponent };